import React from 'react';

import { createClassName } from 'utils/createClassName';

import './notesInputWrapperStyles.scss';

type Props = {};

export const NotesInputWrapperComponent: React.FC<Props> = (props) => {
  const { children } = props;

  const className = createClassName('notesInputWrapper')();

  return <div className={className}>{children}</div>;
};
